import * as React from "react";
import type { SVGProps } from "react";
const SvgHome2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4FD08F"
      stroke="#4FD08F"
      strokeWidth={1.5}
      d="M2.5 10.938a4 4 0 0 1 1.521-3.14l5.5-4.341a4 4 0 0 1 4.958 0l5.5 4.342a4 4 0 0 1 1.521 3.14V17.5a4 4 0 0 1-4 4H16a1 1 0 0 1-1-1v-3a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v3a1 1 0 0 1-1 1H6.5a4 4 0 0 1-4-4z"
    />
  </svg>
);
export default SvgHome2;
